import React from 'react';
import moment from 'moment';


const ViewEmail = function (props)  {
    
    let message = props.store.messages.getById(props.match.params.id);

    const students = props.store.students.collection.filter(student => message.studentIds.includes(student.id))
    let studentNames = students.map(student => student.name);

    console.log(message)
    return (
        <div>
            <h2>View Email</h2>
            <div className="row">
                <div className="comfirmEmailDisplay col-12 col-md-8" dangerouslySetInnerHTML={{ __html: message.emailBody } }></div>
                <div className="col-12 col-md-4">
                    <p><b>To</b>: {studentNames.join(", ")}</p>
                    <p><b>Date</b>: {moment(message.createdDate).format("LL")}</p>

                    <p className="mt-3"><b>From</b>: {message.senderName}</p>

                </div>
            </div>
        </div>
    )
}

export default ViewEmail;